export default __webpack_public_path__ + "static/media/20-web-design-principles-to-follow-featured-image.4366084e.png";